import React, { useEffect, useCallback, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSidebar } from '../../../context/sidebar/SidebarContext';
import { roleContext } from '../../../context/role/context';
import { getSidebarMenu } from './menuFactory';
import { dispatchCustomEvent, listener } from '../../../utils/dispatch';
import './style.css';

function Sidebar() {
    const navigate = useNavigate();
    const location = useLocation();
    const { collapsed, toggle } = useSidebar();
    const { profile } = useContext(roleContext);

    const { menuItems, bottomItems } = getSidebarMenu(profile);

    const handleKeyDown = useCallback((e) => {
        if ((e.metaKey || e.ctrlKey) && e.key === 'b') {
            e.preventDefault();
            toggle();
        }
    }, [toggle]);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [handleKeyDown]);

    useEffect(() => {
        const unbind = listener('toggle-sidebar', toggle);
        return () => { if (unbind) unbind(); };
    }, [toggle]);

    const isActive = (path) => location.pathname === path || (path === '/hub' && (location.pathname === '/' || location.pathname === '/hub'));

    const handleItemClick = (e, path) => {
        if (e.metaKey || e.ctrlKey) {
            return;
        }
        e.preventDefault();
        navigate(path);
    };

    const handleAuxClick = (e, path) => {
        if (e.button === 1) {
            e.preventDefault();
            window.open(window.location.origin + path, '_blank');
        }
    };

    const renderItem = (item) => {
        const active = isActive(item.path);
        const Icon = item.icon;
        return (
            <a
                key={item.id}
                id={`sidebar-menu-${item.id}`}
                href={item.path}
                className={`sidebar-item${active ? ' sidebar-item--active' : ''}`}
                onClick={(e) => handleItemClick(e, item.path)}
                onAuxClick={(e) => handleAuxClick(e, item.path)}
                title={collapsed ? item.label : undefined}
                style={{ textDecoration: 'none' }}
            >
                <Icon className="sidebar-item-icon" size={20} />
                <span className="sidebar-item-label">{item.label}</span>
            </a>
        );
    };

    return (
        <aside className={`sidebar${collapsed ? ' sidebar--collapsed' : ''}`}>
            <div className="sidebar-header">
                <a
                    href="/hub"
                    className="sidebar-brand"
                    onClick={(e) => handleItemClick(e, '/hub')}
                    onAuxClick={(e) => handleAuxClick(e, '/hub')}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                >
                    <div className="sidebar-brand-icon">
                        <span className="sidebar-brand-dot sidebar-brand-dot--left" />
                        <span className="sidebar-brand-dot sidebar-brand-dot--right" />
                        <span className="sidebar-brand-smile" />
                    </div>
                    <span className="sidebar-brand-text">EasyPOS</span>
                </a>
            </div>

            <div className="sidebar-divider" />

            <nav className="sidebar-nav">
                {menuItems.map(renderItem)}
            </nav>

            <div className="sidebar-spacer" />

            <div className="sidebar-divider" />

            <nav className="sidebar-nav sidebar-nav--bottom">
                {bottomItems.map(renderItem)}
            </nav>
        </aside>
    );
}

export default Sidebar;
